// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let operationEnum = {
    'HoneyPacker': 0,
    'PropolisProducer': 1,
    'RoyalJellyProducer': 2,
    'PollinationServices': 3,
    'PollenProducer': 4,
    'QueenBreeder': 5,
    'WaxProducer': 6,
    'HoneyProducer': 7,
    'CombHoney': 8,
    'PackageBee': 9
};

export default operationEnum;
